import axios, { AxiosRequestConfig } from 'axios'

import { appConfig } from '@/app-config/appConfig'
import { HTTPMethod, WithAbortRequestConfig } from '@/lib/requests/types'

export type LoadDataArgs = { method?: HTTPMethod; resourcePath: string; baseUrl?: string } & Pick<
	AxiosRequestConfig,
	'params' | 'data' | 'paramsSerializer' | 'onUploadProgress' | 'responseType'
>

/** @deprecated Add a function to the client */
export function loadData<T>({
	resourcePath,
	baseUrl = appConfig.API_DOMAIN,
	...rest
}: WithAbortRequestConfig & LoadDataArgs) {
	return axios.request<T>({
		baseURL: baseUrl,
		url: resourcePath,
		...rest,
	})
}
